// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CTR1","label":"styles_label__2yosa"};